import React from 'react';
import { Box, TableCell, TableRow, Typography } from '@mui/material';

export function TabPanel({ children, value, index }: { children: React.ReactNode; value: number; index: number }) {
    return value === index ? <Box sx={{ pt: 2 }}>{children}</Box> : null;
}

export function EmptyRow({ colSpan, message }: { colSpan: number; message: string }) {
    return (
        <TableRow>
            <TableCell colSpan={colSpan} align="center" sx={{ py: 4, color: 'text.secondary', border: 'none' }}>
                {message}
            </TableCell>
        </TableRow>
    );
}

export function InfoField({ label, value }: { label: string; value?: React.ReactNode }) {
    return (
        <Box>
            <Typography variant="caption" color="text.secondary">{label}</Typography>
            <Typography variant="body2" component="div" sx={{ mt: 0.25 }}>{value || '-'}</Typography>
        </Box>
    );
}

// Cabeçalho dos painéis aninhados (liquidações dentro do empenho, pagamentos dentro da liquidação)
export function NestedPanelHeader({ icon, title, action, progress }: { icon: React.ReactNode; title: string; action: React.ReactNode; progress: React.ReactNode }) {
    return (
        <Box sx={{ px: 2, py: 1.5, bgcolor: 'action.hover' }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 1 }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    {icon}
                    <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>{title}</Typography>
                </Box>
                {action}
            </Box>
            <Box sx={{ mt: 1 }}>{progress}</Box>
        </Box>
    );
}

export function dashIfEmpty(value?: string | null): string {
    return value || '-';
}
